export class CitizenAddressInfo {
    id: number;
    statusId: number;
    defaultShipping: boolean;
    defaultBilling: boolean;
    verified: boolean;
    addressComplete: boolean;
    formattedAddress: string;
}
